import { css } from '@landr/styled-system/css';

export const planWrapper = css({
    borderRadius: 'base',
    cursor: 'pointer',
    width: '100%',
});

export const mostPopularWrapper = css({
    textAlign: 'center',
    textTransform: 'uppercase',
    backgroundColor: 'surface.primary.clear',
    fontWeight: 700,
    borderTopLeftRadius: 'base',
    borderTopRightRadius: 'base',
    lineHeight: 1,
});

export const innerWrapper = css({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.handle',
    borderBottomLeftRadius: 'base',
    borderBottomRightRadius: 'base',
    paddingX: 'sm',
    paddingY: 'lg',
});
